import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import cmplogo from "assets/img/cmp-logo.svg";

import lockScreenPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import { Auth } from "aws-amplify";
import Amplify from "aws-amplify";
import aws_exports from "../../aws-exports";

Amplify.configure(aws_exports);

class ResetPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      email: "",
      emailState: "",
      code: "",
      codeState: "",
      password: "",
      passwordState: "",
      confirmpassword: "",
      connfirmpasswordState: "",
      tr: false,
      color: "success",
      message: "",
    };
  }

  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  handleChange(event, type) {
    this.setState({
      [event.target.id]: event.target.value,
    });

    switch (type) {
      case "confirmpassword":
        if (this.verifyLength(event.target.value, 8)) {
          this.setState({ confirmpasswordState: "success" });
        } else {
          this.setState({ confirmpasswordState: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 8)) {
          this.setState({ passwordState: "success" });
        } else {
          this.setState({ passwordState: "error" });
        }
        break;
      case "code":
        if (this.verifyLength(event.target.value, 4)) {
          this.setState({ codeState: "success" });
        } else {
          this.setState({ codeState: "error" });
        }
        break;
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ emailState: "success" });
        } else {
          this.setState({ emailState: "error" });
        }
        break;
      default:
      // do nothing
    }
  }

  confirmClick() {
    if (this.state.email === "") {
      this.setState({ emailState: "error" });
    }
    if (this.state.code === "") {
      this.setState({ codeState: "error" });
    }
    if (this.state.password === "") {
      this.setState({ passwordState: "error" });
    }
    if (this.state.confirmpassword === "") {
      this.setState({ confirmpasswordState: "error" });
    }
  }

  showNotification(place) {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        10000
      );
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.confirmClick();
    if (
      this.state.email !== "" &&
      this.state.code !== "" &&
      this.state.password !== "" &&
      this.state.confirmpassword !== ""
    ) {
      try {
        if (this.state.password === this.state.confirmpassword) {
          let email = this.state.email;
          let code = this.state.code;
          let password = this.state.password;
          let confirmpassword = this.state.confirmpassword;
          Auth.forgotPasswordSubmit(email, code, password)
            .then((data) => {
              this.setState({ color: "success" });
              this.setState({
                message: "Password reset successful, Redirecting you to login",
              });
              this.showNotification("tr");
              setTimeout(
                function() {
                  this.props.history.push("/login");
                }.bind(this),
                6000
              );
            })
            .catch((err) => {
              console.log(err["message"]);
              this.setState({ color: "warning" });
              this.setState({ message: err["message"] });
              //this.setState({ message: "Email address/confirmation code miss match. Cannot reset password" });
              this.showNotification("tr");
            });
        } else {
          this.setState({ color: "warning" });
          this.setState({ message: "The passwords entered do not match" });
          this.showNotification("tr");
        }
      } catch (e) {
        this.setState({ color: "warning" });
        this.setState({ message: e["message"] });
        this.showNotification("tr");
      }
    }
  };

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.fullPage}>
        <div className={classes.container}>
          <GridItem xs={12} sm={12} md={3}>
            <Snackbar
              place="tr"
              color={this.state.color}
              message={this.state.message}
              open={this.state.tr}
              closeNotification={() => this.setState({ tr: false })}
              close
            />
          </GridItem>
          <GridContainer justify="center">
            <GridItem xs={12} sm={6} md={4}>
              <form onSubmit={this.handleSubmit}>
                <Card login className={classes[this.state.cardAnimaton]}>
                  <CardHeader
                    className={`${classes.cardHeader} ${classes.textCenter}`}
                    color="primary"
                  >
                    <img src={cmplogo} alt="..." />
                    <h4 className={classes.cardTitle}>
                      Welcome to Customer Management Platform
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}>
                      Please confirm your Registration
                    </h4>

                    <CustomInput
                      success={this.state.emailState === "success"}
                      error={this.state.emailState === "error"}
                      labelText="Email *"
                      id="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => this.handleChange(event, "email"),
                        type: "email",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              email
                            </Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      success={this.state.codeState === "success"}
                      error={this.state.codeState === "error"}
                      labelText="Confirmation Code *"
                      id="code"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => this.handleChange(event, "code"),
                        type: "text",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      success={this.state.passwordState === "success"}
                      error={this.state.passwordState === "error"}
                      labelText="Password *"
                      id="password"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.handleChange(event, "password"),
                        type: "password",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      success={this.state.confirmpasswordState === "success"}
                      error={this.state.confirmpasswordState === "error"}
                      labelText="Confirm Password *"
                      id="confirmpassword"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.handleChange(event, "confirmpassword"),
                        type: "password",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classes.justifyContentCenter}>
                    <Button color="secondary" type="submit">
                      Confirm
                    </Button>
                  </CardFooter>
                </Card>
              </form>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

ResetPasswordPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(lockScreenPageStyle)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPasswordPage.jsx